function cov_2htb0e1c1o() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Info.tsx";
  var hash = "9168628323a5c247529f8878c1c10f4a12d206fb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Info.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 44
        },
        end: {
          line: 6,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9168628323a5c247529f8878c1c10f4a12d206fb"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2htb0e1c1o = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2htb0e1c1o();
var Icon = (cov_2htb0e1c1o().s[0]++, {
  name: 'info',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z\" fill=\"currentColor\"/>\n  <path d=\"M10.5 11.9004C10.5 11.3481 10.9477 10.9004 11.5 10.9004H12.5C13.0523 10.9004 13.5 11.3481 13.5 11.9004V15.9004C13.5 16.4527 13.0523 16.9004 12.5 16.9004H11.5C10.9477 16.9004 10.5 16.4527 10.5 15.9004V11.9004Z\" fill=\"currentColor\"/>\n  <path d=\"M12 9.90039C11.1716 9.90039 10.5 9.22882 10.5 8.40039C10.5 7.57196 11.1716 6.90039 12 6.90039C12.8284 6.90039 13.5 7.57196 13.5 8.40039C13.5 9.22882 12.8284 9.90039 12 9.90039Z\" fill=\"currentColor\"/>"
});
export default Icon;